import globalStore from '$$globalStore';
import app from '$$app';
import resourcesOverload from '../../resourcesOverload';

function onTaskDeleted(event) {
  const tasksMap = globalStore.getters['tasksModel/tasksByIds'];
  const tasksToDelete = [];
  let refreshOverload = false;

  event.data.ids.forEach(taskId => {
    const task = tasksMap[taskId];

    if (!task) {
      return;
    }

    tasksToDelete.push({ id: task.id, gantt_id: task.gantt_id, parent: task.parent });

    if (task.resources?.length) {
      refreshOverload = true;
    }
  });

  if (globalStore.getters['massChange/isEnabled']) {
    const taskIdsToUnselect = [];

    tasksToDelete.forEach(task => {
      const children = globalStore.getters['tasksModel/getAllChildByTask'](+task.gantt_id, +task.id);

      taskIdsToUnselect.push(+task.id);
      taskIdsToUnselect.push(...children.map(t => +t.id));
    });

    if (taskIdsToUnselect.length) {
      globalStore.commit('massChange/removeSelectedItems', { items: taskIdsToUnselect, fromGantt: false }, { root: true });
    }
  }

  if (tasksToDelete.length) {
    globalStore.commit('tasksModel/deleteTasks', { tasks: tasksToDelete, fromGantt: false }, { root: true });
  }

  if (refreshOverload) {
    resourcesOverload.refreshCache();
  }

  app.trigger('onAfterCollaboration', {
    event: event.event,
    tasks: event.data.ids,
    projects: event.data.projectIds,
  });
}

export default onTaskDeleted;
